
import { Options, Vue } from "vue-class-component";
import PageWrapper from "@/layout/pageWrapper/index.vue";

@Options({
  name: "Languages",
  components: { PageWrapper },
})
export default class Languages extends Vue {}
